function changeUnit(val, mult){
  return val * mult;
}

function round(val, n)
{
  n = (typeof n != 'undefined')? n : 1;
  var mult = Math.pow(10, n);

  return Math.round(val * mult) / mult;
}

var SizesWidget = function(elem, x, y)
{
  var DOMElem = elem;
  var cmMult = 2.54;

  this.sizes = {
    inch: {x: x, y: y},
    finch: {},
    cm: {}
  };

  this.init = function(){
    this.sizes.finch = {
      x: this.inchToFinch(this.sizes.inch.x),
      y: this.inchToFinch(this.sizes.inch.y)
    };

    this.sizes.cm = {
      x: round(this.inchToCm(this.sizes.inch.x), 0),
      y: round(this.inchToCm(this.sizes.inch.y), 0)
    };
  }

  this.fill = function(){
    var inchString = DOMElem.querySelector('#inchSizes');
    var finchString = DOMElem.querySelector('#finchSizes');
    var cmString = DOMElem.querySelector('#cmSizes');

    inchString.innerHTML =
      this.formatNum(this.sizes.inch.x) + ' x ' + this.formatNum(this.sizes.inch.y);

    finchString.innerHTML =
      this.formatNum(this.sizes.finch.x) + ' x ' + this.formatNum(this.sizes.finch.y);

    cmString.innerHTML =
      this.formatNum(this.sizes.cm.x, '.', 'cm') +
      ' x ' + this.formatNum(this.sizes.cm.y, '.', 'cm');
  };

  this.formatNum = function(val, sep, ending)
  {
    sep = (typeof sep == 'undefined')? "'" : sep;
    ending = (typeof ending == 'undefined')? '"' : ending;
    if (typeof val === 'object') return val[0] + sep + val[1] + ending;
    else return val.toString().replace('.', sep) + ending;
  };

  this.inchToFinch = function(val){
    return [Math.floor(val / 12, 0), round(val % 12, 0)];
  };

  this.inchToCm = function(val){
    return changeUnit(val, cmMult);
  };

  this.init();
}